import {
  ADD_USER_FORM,
  CLEAR_USER_ERROR,
  CLEAR_USER_LIST_ERROR,
  CLOSE_CREATE_USER_MODAL,
  CREATE_USER_ERROR,
  CREATE_USER_PENDING,
  CREATE_USER_SUCCESS,
  ENABLE_USER_ACCOUNT_FORM,
  OPEN_CREATE_USER_MODAL,
  SET_FILTERED_STATES_LIST_ASYNC,
  SET_INITIAL_STATE,
  SET_LOADING,
  SET_RETAILERS_LIST_ASYNC,
  SET_TEST_VALUE,
  SET_USERS_LIST,
  SET_USERS_LIST_ASYNC,
  SET_USERS_PENDING,
  SUBMIT_ERROR,
  SUBMIT_PENDING,
  SUBMIT_SUCCESS,
  USER_LIST_ERROR,
} from "../users/actionTypes";
import {
  getToken,
  modifyStateList,
  modifyUsersList,
} from "../../helper/common";
import agent from "../services/agent";
import { showSnackbarStatus } from "../snackbar/actions";
import { clearForm } from "../form/actions";
import trimmedValues from "../../helper/trimmer";

export const createUserPending = () => ({
  type: CREATE_USER_PENDING,
});

export const createUserSuccess = () => ({
  type: CREATE_USER_SUCCESS,
});

export const createUserError = (errorMessage) => ({
  type: CREATE_USER_ERROR,
  payload: { errorMessage },
});

export const UserListError = (errorMessage) => ({
  type: USER_LIST_ERROR,
  payload: { errorMessage },
});

export const clearUserListError = () => ({
  type: CLEAR_USER_LIST_ERROR,
});

export const clearCreateUserError = () => ({
  type: CLEAR_USER_ERROR,
});

export const setUserFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const openCreateUserModal = () => ({
  type: OPEN_CREATE_USER_MODAL,
});

export const closeCreateUserModal = () => ({
  type: CLOSE_CREATE_USER_MODAL,
});

export const setUsersPending = () => ({
  type: SET_USERS_PENDING,
});

const setUsersList = (usersOdata) => ({
  type: SET_USERS_LIST,
  payload: { usersOdata },
});

const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: { loading },
});

export const addUserForm = (Addform) => ({
  type: ADD_USER_FORM,
  payload: { Addform }
})

export const enableUserAccountForm = (enableAccount) => ({
  type: ENABLE_USER_ACCOUNT_FORM,
  payload: { enableAccount }
})

const setUsersListForAsyncSelect = (usersList, searchValue) => ({
  type: SET_USERS_LIST_ASYNC,
  payload: { usersListAsync: usersList, searchValueAsync: searchValue },
});

const setRetailerListForAsyncSelect = (retailersList, searchValue) => ({
  type: SET_RETAILERS_LIST_ASYNC,
  payload: { retailersListAsync: retailersList, searchValueAsync: searchValue },
});

const setFilteredStatesListForAsyncSelect = (statesList, searchValue) => ({
  type: SET_FILTERED_STATES_LIST_ASYNC,
  payload: { statesListAsync: statesList, searchValueAsync: searchValue },
});

export const submitPending = () => ({ type: SUBMIT_PENDING });
export const submitSuccess = () => ({ type: SUBMIT_SUCCESS });
export const submitError = () => ({ type: SUBMIT_ERROR });

export const createUser = (data) => (dispatch) => {
  const values = trimmedValues(data);
  dispatch(createUserPending());
  getToken(dispatch).then((accessToken) => {
    agent.User.createUser(accessToken, values)
      .then(() => {
        dispatch(createUserSuccess());
        // dispatch(clearCreateUserError());
        dispatch(clearForm())
        // dispatch(getUsersList());
        dispatch(showSnackbarStatus("User created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createUserError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createUserError(message));
        }
        console.log("Create user server error", err);
        // dispatch(closeCreateUserModal());
        // dispatch(clearForm())
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getUsersList = (currentPage, pagesize, searchDisplayName, searchRoleDisplayName, searchOrgName, searchEmail, searchMobileNumber, searchCreatedBy, searchCreatedByEmail, searchAvailableDevices, searchIsActive, searchIsEnabled, searchCreatedDateTime, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setLoading(true))
  dispatch(setUsersPending());
  dispatch(clearUserListError());
  return getToken(dispatch).then((accessToken) => {
    return agent.User.getUsers(accessToken, currentPage, pagesize, searchDisplayName, searchRoleDisplayName, searchOrgName, searchEmail, searchMobileNumber, searchCreatedBy, searchCreatedByEmail, searchAvailableDevices, searchIsActive, searchIsEnabled, searchCreatedDateTime, sortDirection, sortOrder)
      .then((usersList) => {
        dispatch(setUsersList(usersList));
        dispatch(setLoading(false))
        return Promise.resolve();
      })
      .catch((err) => {
        console.log("getUsers server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(UserListError(message));
        }
        else {
          const message = "Network error";
          dispatch(UserListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        return Promise.resolve();
      });
  });
};

export const getUsersForAsyncSelect = (organisationId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getAssignableUsers(accessToken, searchValue, organisationId)
      .then((usersList) => {
        let userList = modifyUsersList(usersList);
        dispatch(setUsersListForAsyncSelect(userList));
        callback && callback(userList);
      })
      .catch((err) => {
        console.log("getUsers server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

export const getRetailersForAsyncSelect = (organisationId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getAssignableRetailers(accessToken, organisationId)
      .then((retailers) => {
        let retailerList = modifyUsersList(retailers);
        dispatch(setRetailerListForAsyncSelect(retailerList));
        callback && callback(retailerList);
      })
      .catch((err) => {
        console.log("getRetailers server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

export const exportData = () => (dispatch, getState) => {
  return getToken(dispatch).then((accessToken) => {
    return agent.User.exportData(accessToken)
      .then((responseData) => {
        if (responseData) {
          return Promise.resolve(responseData["value"]);
        }
      })
      .catch((err) => {
        console.log("user data export server error", err);
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const getFilteredStatesForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.User.getFilteredStates(accessToken, searchValue)
      .then((statesList) => {
        let statesListOptions = modifyStateList(statesList);
        dispatch(setFilteredStatesListForAsyncSelect(statesListOptions));
        callback && callback(statesListOptions);
      })
      .catch((err) => {
        console.log("getFilteredStatesForAsyncSelect for dropdown server error", err
        );
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};
